import { css } from 'linaria';
import { styled } from 'linaria/react';
import React from 'react';

type Level = 0 | 1;

type UspCardProps = {
  cardNumber: number;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const uspCardsWrapper = css`
  display: grid;
  row-gap: 24px;

  @media (--only-tablet) {
    row-gap: 16px;
  }

  @media (--only-mobile) {
    row-gap: 12px;
  }
`;

export const StyledUspCards = styled.div<UspCardProps>`
  display: grid;
  grid-template-columns: ${({ cardNumber }: UspCardProps) => `repeat(${cardNumber}, 1fr)`};
  column-gap: 24px;

  @media (--only-tablet) {
    column-gap: 16px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
`;

export const uspCardTitle = css`
  margin-bottom: 24px;
`;

export const uspCard = css`
  border-radius: var(--rounding-l);
`;

export const uspCardsGridLevelMap: Record<Level, string> = {
  0: css`
    grid-template-rows: 176px;

    @media (--only-tablet) {
      grid-template-rows: 140px;
    }

    @media (--only-mobile) {
      grid-template-rows: auto;
    }
  `,
  1: css`
    grid-template-rows: 224px;

    @media (--only-tablet) {
      grid-template-rows: 190px;
    }

    @media (--only-mobile) {
      grid-template-rows: auto;
    }
  `,
};

export const upsCardImage = css`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-l);
`;
